import React, { FunctionComponent } from 'react'
import { Text, Flex } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../../../../utils/responsive'
import { Money } from '@afterpay/types'
import { useMoney } from '../../../../../component/Money/useMoney'
import { useAppRouter } from '../../../../../state/hooks'
import styles from './style.module.css'
import { useTranslation } from '../../../../../utils/convergence'

type SummaryItemProps = {
  name: string
  amount: Money
  downPaymentAmount?: Money
  bold?: boolean
}

export const SummaryItem: FunctionComponent<SummaryItemProps> = (props): JSX.Element => {
  const { name, amount, downPaymentAmount, bold = false } = props
  const { t } = useTranslation()
  const { textSize, smallTextSize } = useCheckoutSizes()
  const { locale } = useAppRouter()
  const { formatMoney } = useMoney({
    locale,
    currency: amount?.currency,
  })

  return (
    <Flex direction='column' className={styles.container}>
      <Flex justifyContent='space-between' className={styles.item}>
        <Text size={textSize} bold={bold}>
          {name}
        </Text>
        <Text size={textSize} bold={bold}>
          {formatMoney(amount.amount)}
        </Text>
      </Flex>
      {downPaymentAmount && (
        <Flex justifyContent='space-between' className={styles.item}>
          <Text size={smallTextSize} color='Subtle'>
            {t('summary:downPayment')}
          </Text>
          <Text size={smallTextSize} color='Subtle'>
            -{formatMoney(downPaymentAmount.amount)}
          </Text>
        </Flex>
      )}
    </Flex>
  )
}
